export const TYPE_QUEUES = 'queues'
export const TYPE_TILLS = 'tills'
export const TYPE_DISPLAYS = 'displays'
